import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateUserDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import CompaniesMultiSelector from '../Company/CompaniesMultiSelector';

interface UserEditorTabNewProps {
  user: CreateUpdateUserDto | undefined;
  propertyChange: (obj: Partial<CreateUpdateUserDto>) => void;
}

export const UserEditorTabNew: React.FC<UserEditorTabNewProps> = ({
  user,
  propertyChange,
}) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow controlId="company" label="Firmy/filie">
        <CompaniesMultiSelector
          selectedCompanyIds={user?.companyIds}
          externalReferralOnly={true}
          onChange={options =>
            propertyChange({ companyIds: options.map(o => o.value) })
          }
        />
      </FormRow>
      <FormRow controlId="emailWithReferral" label="E-mail ze skier. zewn.">
        <Form.Check
          type="checkbox"
          checked={user?.emailWithReferral ? true : false}
          onChange={e =>
            propertyChange({ emailWithReferral: e.target.checked })
          }
        />
      </FormRow>
    </Form>
  );
};
